import React from "react"

const Hero = () => {
  return (
    <div className="hero" data-aos="fade-down" data-aos-delay="500">
      <div className="container">
        <div className="hero__content">
          <img className="hero__image" src="./good-morning.svg" />
        </div>
      </div>
    </div>
  )
}

export default Hero
